import { KeyValuePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoCheckboxFields } from '@demo/data/demo-cipo-fields';
import { CipoCheckboxComponent } from '@shared/components/fields/cipo-checkbox/cipo-checkbox.component';
import { CipoCheckboxControl } from '@shared/components/fields/common';

@Component({
  selector: 'app-demo-cipo-checkbox',
  imports: [CipoCheckboxComponent, FlexLayoutModule, KeyValuePipe],
  templateUrl: './demo-cipo-checkbox.component.html',
})
export class DemoCipoCheckboxComponent {
  dialog = inject(MatDialog);

  form = signal(new FormGroup<{ [x: string]: CipoCheckboxControl }>({}));

  constructor() {
    DemoCheckboxFields.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoCheckboxControl(defaultValue, props);
      this.form().addControl(name, control);
    });
  }
}
